import React from 'react';
import { Modal } from '@material-ui/core';
import { X } from 'phosphor-react';
import {
  hideUploadSuccessModal,
  setDocumentUploadComplete,
} from '../../../../../actions/dashboard';
import { CheckmarkBlob } from '../../../../utility/Icons';
import styles from '../../../../../styles/sass/components/GetPreapproved.module.scss';
import { connect } from 'react-redux';

interface Props {
  modalStyle: any;
  showDocumentUploadSuccessModal: boolean;
  dispatch: Function;
}

export const DocumentsReceivedModal: React.FC<Props> = ({
  modalStyle,
  showDocumentUploadSuccessModal,
  dispatch,
}: Props) => {
  const handleDocumentUploaded = () => {
    // TODO: Add logic for sending a notification that documents have been uploaded
    dispatch(setDocumentUploadComplete());
    dispatch(hideUploadSuccessModal());
  };

  return (
    <Modal
      open={showDocumentUploadSuccessModal}
      onClose={() => dispatch(hideUploadSuccessModal())}
      style={modalStyle}
    >
      <div className={styles.documentsReceivedContainer}>
        <div className={styles.header}>
          <CheckmarkBlob width="66" height="60" style={{ margin: '24px 0' }} />
          <button
            className={styles.closeButton}
            onClick={() => dispatch(hideUploadSuccessModal())}
          >
            <X size={32} color="#323232" weight="regular" />
          </button>
        </div>
        <div>
          <p className={styles.mainText}>We’ve received your documents!</p>
          <p className={styles.subText}>
            Our team will look over your documents and e-mail you with next
            steps.
          </p>
        </div>
        <div className={styles.doneButtonContainer}>
          <button
            className={styles.doneButton}
            onClick={handleDocumentUploaded}
          >
            Cool!
          </button>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state: any) => ({
  showDocumentUploadSuccessModal:
    state.dashboard.showDocumentUploadSuccessModal,
});

export default connect(mapStateToProps)(DocumentsReceivedModal);
